import { styled, Typography } from '@mui/material';

const StyledSessionFieldsTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(20),
  marginBottom: theme.spacing(1)
}));

export default StyledSessionFieldsTitle;
